export default {
	"contactUs": {
		"title": ". ھېساباتى تەسىس قىلغاندا ، سىز ئەڭ نوپۇزلۇق نازارەت قىلىپ باشقۇرۇش ، قوغداش ۋە ئەڭ بىخەتەر مەبلەغ كاپالىتىگە ئېرىشەلەيسىز ، دەرھال ئېچىلىدۇEBC",
		"title1": "ھەر بىر ئەستايىدىل سودا قىلىدىغان خېردار ئەستايىدىل مۇئامىلە قىلىشقا ئەرزىيدۇ.",
		"code": "دەلىللەش كودى",
	},
	"dividend": {
		"title": "پاي ئۆسۈمى ",
		"title1": "CFD پاي ئۆسۈمى پايدىلىنىش: ",
		"desc": "دىققەت: CFD پاي ئۆسۈمىنى ئېلىش سىزنىڭ MT4 ھېساباتىڭىزدىكى قالدۇق سوممىدا ئامانەت قويۇش ياكى پۇل ئېلىش شەكلىدە ئەكس ئەتتۈرۈلىدۇ، ئىزاھات« Dividend» دەپ يېزىلىدۇ",
		"btn": "مەبلەغ سېلىشنى باشلاش"
	},
	"notice": "يېقىندا بىز  EBC Group توردا شىفىرلىق پۇل سودا مەھسۇلاتىنى تەمىنلەيدىغان« EBankc »   نامىلىق شىركەت بىلەن باغلىنىشلىق بولۇپ قالغانلىقىنى بايقىدۇق. <br/><br/>شۇڭا بۇنىڭغا بىز ئېنىق بايانات ئېلان قىلىمىز :EBC Group تور بېكىتى www ebc.com ۋە www.ebcfin.com تور بېكىتىدە ، تەمىنلىگەن مەھسۇلات ئۇچۇرلىرى تەپسىلىي تونۇشتۇرۇلغان ، بۇنىڭدا شىفىرلاشتۇرۇلغان پۇل مەھسۇلاتىنى ئۆز ئىچىگە ئالمايدۇ.<br/><br/>شۇنىڭ بىلەن بىر ۋاقىتتا ، EBC Financial Group (UK) Ltd پەقەت بىرلا قانۇنلۇق تور ئادرېسى بار www.ebcfin.co.uk<br/><br/>توربەتتە ئوخشاشلا تەمىنلىگەن مەھسۇلات ئومۇميۈزلۈك تونۇشتۇرۇلغان بولۇپ ، شىفىرلاشتۇرۇلغان پۇل بۇنىڭ ئىچىدىكى مەھسۇلات ئەمەس. بارلى EBC گۇرۇھ شىركەتلەر ئۆز تىجارەت ئورنىنىڭ ئەدلىيە باشقۇرۇش تەۋەلىكىدىكى رايوننىڭ قائىدىسى ۋە قانۇن - نىزاملىرىغا ئاساسەن تىجارەت قىلىدۇ ، ھەمدە بارلىق زۆرۈر تەدبىرلەرنى قوللىنىپ ، ھەرقانداق ئۈچىنچى تەرەپنىڭ ھوقۇق بېرىلمىگەن تۈردە ئۆزىنىڭ ماركىسىنى ئىشلىتىشىنى توسىدۇ.",
	"contact": {
		"title": "مەبلىغىڭىز مۇشۇ يەردىن باشلىنىدۇ",
		"pageTitle": "مەسلىھەت سوراشنى باشلاش",
		"pageEnTitle": "Inquiry",
		"name": "ئىسىم-فامىلە",
		"sexList": [{
			"label": "خانقىز",
			"value": "sir"
		}, {
			"label": "ئەپەندىم",
			"value": "lady"
		}],
		"email": "پوچتا ساندۇقى / تېلېفون",
		"btn": "تاپشۇرۇش",
		"tips1": "ئىسمىڭىزنى كىرگۈزۈڭ!",
		"tips2": "ئالاقىلىشىش ئۇسۇلىڭىزنى كىرگۈزۈڭ!",
		"tips3": "سۆز قالدۇرۇش مۇۋەپپەقىيەتلىك بولدى!",
		"tips4": "توغرا بولغان دەلىللەش نومۇرىنى كىرگۈزۈڭ!"
	},
	"column1": {
		"placeholder": "پۈتۈن  تور بېكەت بويىچە ئىزدەش",
		"login": "ئەزا كىرىش",
		"langText": " تىل/تور بېكىتى رايون",
		"langList": [{
			"text": "简体",
			"value": "zh_CN"
		}, {
			"text": "繁体",
			"value": "zh_TW"
		}, {
			"text": "English",
			"value": "en_US"
		}, {
			"text": "한국어",
			"value": "ko_KR"
		}, {
			"text": "日本語",
			"value": "ja_JP"
		}]
	},
	"linkList": [{
		"title": "ھېسابات ۋە شەرتلەر",
		"list": [{
			"label": "سودا ھېساباتى",
			"link": "/TradingAccount"
		}, {
			"label": "سودا مەھسۇلاتلىرى",
			"link": "/tradingproduct"
		}, {
			"label": "پىشاڭ پەرقى",
			"link": "/leverage-margin"
		},
		{
			"label": "پۇل ئامانەت قويۇش ۋە ئېلىش",
			"link": "/funding"
		},
		{
			"label": "پاي ئۆسۈمى",
			"link": "/dividend"
		}
		]
	}, {
		"title": "سودا قوراللىرى",
		"list": [{
			"label": "MT4 چۈشۈرۈش",
			"link": "/MT4"
		},{
			"label": "MT5 چۈشۈرۈش",
			"link": "/MT5"
		}, {
			"label": "MT4 سودا قوراللىرى",
			"link": "/tools"
		}, {
			"label": "PAMM",
			"link": "/PAMM"
		}
		]
	}, {
		"title": "ئالىي مەكتەپ",
		"list": [{
			"label": "ئۆگىنىش مەركىزى ",
			"link": "/LearningCenter"
		}, {
			"label": "سانلىق مەلۇمات مەركىزى ",
			"link": "/lab"
		}
		]
	}, {
		"title": "ئەڭ يېڭى ۋەقەلەر",
		"list": [{
			"label": "سودا مۇسابىقىسى",
			"link": "/win"
		},
		//  {
		// 	"label": "ئەڭ كۈچلۈك سودا مۇھىتىغا جەڭ ئېلان قىلىش",
		// 	"link": "/no1"
		// },
		 {
			"label": " مائاش پىلانى",
			"link": "/pay"
		}]
	}, {
		"title": "ھەمكارلىق ھالىتى",
		"list": [{
			"label": "ساودا قىلغۇچىلارنى كۈچەيتىش تۆرى",
			"link": "/affiliate-programmes"
		}, {
			"label": "ئورگان مۇلازىمىتى",
			"link": "/service"
		}, {
			"label": "ئاساسى تېخنىكا",
			"link": "/technology"
		}]
	}, {
		"title": "    ھەققىدە EBC    ",
		"list": [{
			"label": "WHY EBC",
			"link": "/about-us"
		}, {
			"label": "قانۇن ھۆججىتى",
			"link": "/LegalDocumen"
		}, {
			"label": "Sustainability & Impact",
			"link": "/ESG"
		}, {
			"label": "FAQ",
			"link": "/FAQ"
		}, {
			"label": "رەسمىي قانال دەلىللەش",
			"link": "/official-verification"
		}]
	}],
	"headlist": [{
		"text": "باش بەت ",
		"url": "/"
	}, {
		"text": "سودا ",
		"menu": [{
			"text": "سودا مەھسۇلاتى ",
			"url": "/tradingproduct"
		}, {
			"text": "ﺳﻮدا ﮬﯧﺴﺎﺑﻰ ",
			"url": "/TradingAccount"
		}, {
			"text": "سودا شەرتى ",
			"menu": [{
				"text": "پۇل كىرگۈزۈش پۇل چىقىرىش",
				"url": "/funding"
			}, {
				"text": "كاپالەت پۇلى& پىشاڭ ",
				"url": "/leverage-margin"
			}]
		}, {
			"text": "سودا سۇپىسى ",
			"menu": [{
				"text": "MT4",
				"url": "/MT4"
			}, {
				"text": "MAM",
				"url": "/MAM"
			}]
		}, {
			"text": "پاي ئۆسۈمى",
			"url": "/dividend"
		}]
	}, {
		"text": " سايمان ‎ۋە LAB",
		"menu": [{
			"text": "ئۆگىنىش مەركىزى",
			"url": "/LearningCenter"
		}, {
			"text": "سانلىق مەلۇمات مەركىزى",
			"url": "/lab"
		}]
	}, {
		"text": "ئاپپارات كەسپى",
		"menu": [{
			"text": "تۆۋەن قاتلام پەن-تېخنىكىسى",
			"url": "/technology"
		}, {
			"text": "ئاپپارات مۇلازىمىتى",
			"url": "/service"
		}]
	}, {
		"text": "ھەمكارلىق ھەمراھى",
		"url": "/partner"
	}, {
		"text": "ئەڭ يېڭى پائالىيەت",
		"menu": [{
			"text": " مائاش پىلانى",
			"url": "/pay"
		}]
	}, {
		"text": "‎توغرىسىدا EBC",
		"menu": [{
			"text": "Why EBC",
			"url": "/about-us"
		}, {
			"text": "FAQ",
			"url": "/FAQ"
		}]
	}, {
		"text": "سودا مۇسابىقىسى",
		"url": "/win"
	}, {
		"text": "سودا مەھەللىسى",
		"url": "https://ebcfinsns.co/"
	}, {
		"text": "ھېساب ئېچىش",
		"url": "https://client.myebc.co/signup?bid=5s71xp"
	}],
	"login": "ھەقسىز",
	"zhuce": "ھېساب ئېچىش",
	"gendan": "ھۆججەتلىك فىلىم جەمئىيىتى",
	"pdfLang": "cn",
	"bannerLang": "ug",
	"language": 'ئۇيغۇر تىلى',
	"className": "vi-box",
	"text": "EBC Financial Group بىر قىسىم ئورگانلار تەرىپىدىن ھەمبەھر قىلىنغان بىر تۇنجى ماركىدۇر، جۈملىدىن:<br>EBC Financial Group (SVG) LLC ساينت ۋىنسېنت ۋە گرېنادىنىس پۇل مۇئامىلە مۇلازىمەت باشقۇرۇش ئىدارىسى ھوقۇق بەرگەن ۋە نازارەت قىلىپ باشقۇرغان، رويخەتكە ئالدۇرغان نومۇرى 353 LLC 2020<br>باشقا ئالاقىدار ئەمەلىي گەۋدىلەر<br>EBC Financial Group (UK) Limited ئەنگلىيە پۇل مۇئامىلە ھەرىكىتىنى نازارەت قىلىپ باشقۇرۇش ئىدارىسى ھوقۇق بەرگەن ۋە نازارەت قىلىپ باشقۇرغان، نازارەت قىلىپ باشقۇرۇش نومۇرى 927552. تور ئادرېسى:<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC مالیۋه گۇرۇپپىسى (ئاۋستىرالىيە) Pty Ltd (ACN: 619 073 237) ئاۋستىرالىيە بايلىق ۋە مەبلەغ سالماق كومىسسىيىسى (نومۇر: 500991) تەرىپىدىن رۇخسەت قىلىنغان ۋە تەرتىپكە سېلىنغان. EBC مالیۋه گۇرۇپپىسى (ئاۋستىرالىيە) Pty Ltd، EBC مالیۋه گۇرۇپپىسى (SVG) LLC نىڭ بىر تۇغقان شىركىتىدۇر. بۇ ئىككى شىركەت ئالاقىدار بولسىمۇ، بىراق ئۇلار ئوخشىمىغان ئۇنىۋېرسال باشقۇرىلىدۇ. بۇ تور بەتتە تەمىنلەنگەن مالىيە ‌مەھسۇلاتلىرى ۋە كۆرسىتىلىۋاتقان خىزمەتلەر ئاۋستىرالىيە شىركىتى تەرىپىدىن تەمىنلەنگەن ئەمەس، ھەم ئاۋستىرالىيە شىركىتىگە نىسبەتەن ھەر قانداق ئىنكاسقا دىققەت قىلىش تەلەپ قىلىنمايدۇ.<br>EBC Financial Group (Cayman) Limitedكايمان ئارىلى پۇل باشقۇرۇش ئورگىنىنىڭ ئىجازەتنامىسى ۋە باشقۇرۇشى (نومۇرى: 2038223). تور بېكەت:<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>شىركەت ئادرېسى: Level 17, The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB يوللانما ئادرېسى: cs@ebc.com تېلېفون: 20 3376 9662 44+<br>جاۋاپكارلىقنى كەچۈرۈم قىلىش : EBC پۇل مۇئامىلە گوروھى ھەرقانداق مەۋھۇم پۇل كەسپىگە قاتناشمايدىغانلىقىنى ياكى مەۋھۇم پۇل CFD مۇلازىمىتى بىلەن تەمىنلىمەيدىغانلىقىنى ئېنىق بېكىتتى. بىزنىڭ پۇل-مۇئامىلە مۇلازىمىتىمىز پەقەت ئەنئەنىۋى پۇل-مۇئامىلە مەھسۇلاتلىرى ئۈچۈندۇر. خېرىدارلارغا مەلۇمكى، ئەگەر EBC نامىدا مەۋھۇم پۇلغا مۇناسىۋەتلىك مۇلازىمەتنى تەۋسىيە قىلسا، بىردەك خاتا يېتەكلەش دەپ قارىلىدۇ ھەمدە ھوقۇق بېرىلمىگەن بولىدۇ.ھەرقانداق ئۆتمۈشتىكى ئىپادىسى كەلگۈسىدىكى ئىپادىگە ۋەكىللىك قىلمايدۇتور بېكىتىنىڭ مەزمۇنى پەقەت پايدىلىنىشقا ئىشلىتىلىدۇ ، ھېچقانداق مەبلەغ سېلىش تەكلىپىنى ھاسىل قىلمايدۇ<br>رايون چەكلىمىسى :  EBC بەزى ئەدلىيەلىك باشقۇرۇش تەۋەلىكىدىكى پۇقرالار ۋە ئاھالىلەرنى ھېچقانداق مۇلازىمەت بىلەن تەمىنلىمەيدۇ، تۆۋەندىكى  رايونلارنى  ئۆز  ئىچىگە  ئالىدۇ : ئافغانىستان، بېلارۇسىيە، بىرما ، كانادا، ئوتتۇرا ئافرىقا جۇمھۇرىيىتى، كونگو، كۇبا، كونگو دېموكراتىك جۇمھۇرىيىتى، ئېرىترىيە، ھايتى، ئىران، ئىراق، لىۋان، لىۋىيە، مالايسىيا، مالى، چاۋشيەن ( چاۋشيەن دېموكراتىك خەلق جۇمھۇرىيىتى ) رۇسىيە، سومالى، سۇدان، جەنۇبىي سۇدان، سۇرىيە، ئۇكرائىنا ( قىرىم، دونېچىك ۋە لۇگانسك رايونىنى ئۆز ئىچىگە ئالىدۇ )، ئامېرىكا، ۋېنېزۇئېلا ۋە يەمەننى ئۆز ئىچىگە ئالىدۇ.تېخىمۇ كۆپ مۇناسىۋەتلىك  ئۇچۇرلار  ۋە  دائىم ئۇچرايدىغان مەسىلىلەرنىڭ جاۋابىنى تەكشۈرۈپ بېقىڭ.<br>بەلگىلىمىگە ئۇيغۇن ئاشكارىلاش : شىركەت تور بېكىتنى پۈتۈن دۇنيا مىقياسىدا كۆرگىلى بولىدۇ ،  مەخسۇس مەلۇم بىر  ئەمەلىي گەۋدىگەقارىتىلمايدۇ . سىزنىڭ ھوقۇق ۋە مەجبۇرىيىتىڭىزنى  ئۆزىڭىز تاللىغان رايوندىكى  نازارەت قىلىپ باشقۇرۇش ئورنى  بەلگىلەيدۇ . شۇجايدىكى قانۇن ۋە نازارەت قىلىپ باشقۇرۇش ئورنى  سىزنىڭ بۇ تور بېكەتكە  كىرىشى، چۈشۈرۈش، تارقىتىش، بەھرىمەن بولۇشياكى ئىشلىتىش ھوقوقىڭىزنى   چەكلىشى  مۇمكىن<br>خېيىم-خەتەرلىك سودا مەھسۇلاتلىرى ئاشكارىلاندى:CFDمۇرەككەپ پۇل مۇئامىلە مەھسۇلاتى  بولۇپ ، پىشاڭ ئىشلىتىش تېز سۈرئەتتەزىيان تارتىش خەتىرىگە ۋەكىللىك قىلىدۇ. كاپالەت پۇلى سودىسى خەتەرلىك، بەلكىم بارلىق مەبلەغ سالغۇچىلارغا ماس كەلمەسلىكىمۇمكىن. سىز ئۆزىڭىزنىڭ نىشانى، مالىيە ئەھۋالى ۋە خەۋپ-خەتەر قىزىقىشىغا بىرلەشتۈرۈپ يۇقارقى ئۇچۇرلاردىن  پايدىلانسىڭىز  بولىدۇ.بىز سىزنىڭ مۇستەقىل پىكىر قىلىپ ، مەبلەغ سېلىش تەدبىرى بەلگىلەشتىن بۇرۇن بۇنىڭ ئىچىدىكى خېيىم-خەتەرنى تولۇقچۈشىنىشىڭىزگە كاپالەتلىك قىلىشىڭىزنى تەۋسىيە قىلىمىز. سودا قىلىشتىن بۇرۇن، ئالاقىدار خەۋپ-خەتەرنى ئاشكارىلاشباياناتىنى تەپسىلىي ئوقۇڭ",
	"waptext": "EBC Financial Group بىر قىسىم ئورگانلار تەرىپىدىن ھەمبەھر قىلىنغان بىر تۇنجى ماركىدۇر، جۈملىدىن:<br>EBC Financial Group (SVG) LLC ساينت ۋىنسېنت ۋە گرېنادىنىس پۇل مۇئامىلە مۇلازىمەت باشقۇرۇش ئىدارىسى ھوقۇق بەرگەن ۋە نازارەت قىلىپ باشقۇرغان، رويخەتكە ئالدۇرغان نومۇرى 353 LLC 2020<br>باشقا ئالاقىدار ئەمەلىي گەۋدىلەر<br>EBC Financial Group (UK) Limited ئەنگلىيە پۇل مۇئامىلە ھەرىكىتىنى نازارەت قىلىپ باشقۇرۇش ئىدارىسى ھوقۇق بەرگەن ۋە نازارەت قىلىپ باشقۇرغان، نازارەت قىلىپ باشقۇرۇش نومۇرى 927552. تور ئادرېسى:<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC مالیۋه گۇرۇپپىسى (ئاۋستىرالىيە) Pty Ltd (ACN: 619 073 237) ئاۋستىرالىيە بايلىق ۋە مەبلەغ سالماق كومىسسىيىسى (نومۇر: 500991) تەرىپىدىن رۇخسەت قىلىنغان ۋە تەرتىپكە سېلىنغان. EBC مالیۋه گۇرۇپپىسى (ئاۋستىرالىيە) Pty Ltd، EBC مالیۋه گۇرۇپپىسى (SVG) LLC نىڭ بىر تۇغقان شىركىتىدۇر. بۇ ئىككى شىركەت ئالاقىدار بولسىمۇ، بىراق ئۇلار ئوخشىمىغان ئۇنىۋېرسال باشقۇرىلىدۇ. بۇ تور بەتتە تەمىنلەنگەن مالىيە ‌مەھسۇلاتلىرى ۋە كۆرسىتىلىۋاتقان خىزمەتلەر ئاۋستىرالىيە شىركىتى تەرىپىدىن تەمىنلەنگەن ئەمەس، ھەم ئاۋستىرالىيە شىركىتىگە نىسبەتەن ھەر قانداق ئىنكاسقا دىققەت قىلىش تەلەپ قىلىنمايدۇ.<br>EBC Financial Group (Cayman) Limitedكايمان ئارىلى پۇل باشقۇرۇش ئورگىنىنىڭ ئىجازەتنامىسى ۋە باشقۇرۇشى (نومۇرى: 2038223). تور بېكەت:<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>شىركەت ئادرېسى: Level 17, The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB يوللانما ئادرېسى: cs@ebc.com تېلېفون: 20 3376 9662 44+<br>جاۋاپكارلىقنى كەچۈرۈم قىلىش : EBC پۇل مۇئامىلە گوروھى ھەرقانداق مەۋھۇم پۇل كەسپىگە قاتناشمايدىغانلىقىنى ياكى مەۋھۇم پۇل CFD مۇلازىمىتى بىلەن تەمىنلىمەيدىغانلىقىنى ئېنىق بېكىتتى. بىزنىڭ پۇل-مۇئامىلە مۇلازىمىتىمىز پەقەت ئەنئەنىۋى پۇل-مۇئامىلە مەھسۇلاتلىرى ئۈچۈندۇر. خېرىدارلارغا مەلۇمكى، ئەگەر EBC نامىدا مەۋھۇم پۇلغا مۇناسىۋەتلىك مۇلازىمەتنى تەۋسىيە قىلسا، بىردەك خاتا يېتەكلەش دەپ قارىلىدۇ ھەمدە ھوقۇق بېرىلمىگەن بولىدۇ.ھەرقانداق ئۆتمۈشتىكى ئىپادىسى كەلگۈسىدىكى ئىپادىگە ۋەكىللىك قىلمايدۇتور بېكىتىنىڭ مەزمۇنى پەقەت پايدىلىنىشقا ئىشلىتىلىدۇ ، ھېچقانداق مەبلەغ سېلىش تەكلىپىنى ھاسىل قىلمايدۇ<br>رايون چەكلىمىسى :  EBC بەزى ئەدلىيەلىك باشقۇرۇش تەۋەلىكىدىكى پۇقرالار ۋە ئاھالىلەرنى ھېچقانداق مۇلازىمەت بىلەن تەمىنلىمەيدۇ، تۆۋەندىكى  رايونلارنى  ئۆز  ئىچىگە  ئالىدۇ : ئافغانىستان، بېلارۇسىيە، بىرما ، كانادا، ئوتتۇرا ئافرىقا جۇمھۇرىيىتى، كونگو، كۇبا، كونگو دېموكراتىك جۇمھۇرىيىتى، ئېرىترىيە، ھايتى، ئىران، ئىراق، لىۋان، لىۋىيە، مالايسىيا، مالى، چاۋشيەن ( چاۋشيەن دېموكراتىك خەلق جۇمھۇرىيىتى ) رۇسىيە، سومالى، سۇدان، جەنۇبىي سۇدان، سۇرىيە، ئۇكرائىنا ( قىرىم، دونېچىك ۋە لۇگانسك رايونىنى ئۆز ئىچىگە ئالىدۇ )، ئامېرىكا، ۋېنېزۇئېلا ۋە يەمەننى ئۆز ئىچىگە ئالىدۇ.تېخىمۇ كۆپ مۇناسىۋەتلىك  ئۇچۇرلار  ۋە  دائىم ئۇچرايدىغان مەسىلىلەرنىڭ جاۋابىنى تەكشۈرۈپ بېقىڭ.<br>بەلگىلىمىگە ئۇيغۇن ئاشكارىلاش : شىركەت تور بېكىتنى پۈتۈن دۇنيا مىقياسىدا كۆرگىلى بولىدۇ ،  مەخسۇس مەلۇم بىر  ئەمەلىي گەۋدىگەقارىتىلمايدۇ . سىزنىڭ ھوقۇق ۋە مەجبۇرىيىتىڭىزنى  ئۆزىڭىز تاللىغان رايوندىكى  نازارەت قىلىپ باشقۇرۇش ئورنى  بەلگىلەيدۇ . شۇجايدىكى قانۇن ۋە نازارەت قىلىپ باشقۇرۇش ئورنى  سىزنىڭ بۇ تور بېكەتكە  كىرىشى، چۈشۈرۈش، تارقىتىش، بەھرىمەن بولۇشياكى ئىشلىتىش ھوقوقىڭىزنى   چەكلىشى  مۇمكىن<br>خېيىم-خەتەرلىك سودا مەھسۇلاتلىرى ئاشكارىلاندى:CFDمۇرەككەپ پۇل مۇئامىلە مەھسۇلاتى  بولۇپ ، پىشاڭ ئىشلىتىش تېز سۈرئەتتەزىيان تارتىش خەتىرىگە ۋەكىللىك قىلىدۇ. كاپالەت پۇلى سودىسى خەتەرلىك، بەلكىم بارلىق مەبلەغ سالغۇچىلارغا ماس كەلمەسلىكىمۇمكىن. سىز ئۆزىڭىزنىڭ نىشانى، مالىيە ئەھۋالى ۋە خەۋپ-خەتەر قىزىقىشىغا بىرلەشتۈرۈپ يۇقارقى ئۇچۇرلاردىن  پايدىلانسىڭىز  بولىدۇ.بىز سىزنىڭ مۇستەقىل پىكىر قىلىپ ، مەبلەغ سېلىش تەدبىرى بەلگىلەشتىن بۇرۇن بۇنىڭ ئىچىدىكى خېيىم-خەتەرنى تولۇقچۈشىنىشىڭىزگە كاپالەتلىك قىلىشىڭىزنى تەۋسىيە قىلىمىز. سودا قىلىشتىن بۇرۇن، ئالاقىدار خەۋپ-خەتەرنى ئاشكارىلاشباياناتىنى تەپسىلىي ئوقۇڭ",
}

